import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import PaginatedListState from 'flarum/common/states/PaginatedListState';
export default class DialogListState extends PaginatedListState {
  constructor(params, page, perPage) {
    if (page === void 0) {
      page = 1;
    }
    if (perPage === void 0) {
      perPage = null;
    }
    super(params, page, perPage);
    _defineProperty(this, "lastCount", 0);
  }
  get type() {
    return 'dialogs';
  }
  getAllItems() {
    return super.getAllItems();
  }
  requestParams() {
    const params = {
      include: ['lastMessage', 'users.groups'],
      filter: this.params.filter || {},
      sort: this.currentSort() || this.sortValue(Object.values(this.sortMap())[0])
    };
    return params;
  }
  sortMap() {
    const map = {};
    map.latest = '-lastMessageAt';
    map.newest = '-createdAt';
    map.oldest = 'createdAt';
    return map;
  }
  load() {
    var _app$session$user;
    if (((_app$session$user = app.session.user) == null ? void 0 : _app$session$user.attribute('messageCount')) !== this.lastCount) {
      var _app$session$user2;
      this.pages = [];
      this.location = {
        page: 1
      };
      this.lastCount = ((_app$session$user2 = app.session.user) == null ? void 0 : _app$session$user2.attribute('messageCount')) || 0;
    }
    if (this.pages.length > 0) {
      return Promise.resolve();
    }
    return super.loadNext();
  }
  markAllAsRead() {
    return app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/dialogs/read'
    }).then(() => {
      app.dialogs.getAllItems().forEach(dialog => {
        dialog.pushAttributes({
          unreadCount: 0
        });
      });
      app.session.user.pushAttributes({
        messageCount: 0
      });
      app.dropdownDialogs.clear();
      m.redraw();
    });
  }
}
flarum.reg.add('flarum-messages', 'forum/states/DialogListState', DialogListState);